import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { FollowListPage } from "@/features/social/components/follow-list-page";
import { useI18n } from "@/providers/i18n-provider";

function SocialFollowersRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Tus seguidores`)}
      description={t(msg`Inicia sesión para ver quién sigue tu colección.`)}
    >
      <FollowListPage mode="followers" />
    </AuthPlaceholder>
  );
}

export const socialFollowersRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/social/followers",
  component: SocialFollowersRoutePage,
});
